import React from 'react';
import { Box, Typography } from '@mui/material';

import Description from 'components/CareSummary/Description';
import Empty from 'components/CareSummary/Empty';
import Title from 'components/CareSummary/Title';
import { Container } from 'shared-components/Container';
import { useGetProfileParticipantTasksQuery, useGetProfileParticipantTaskQuery } from 'store/api/pkd/endpoints/participantTask';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { TaskTitles } from 'utils/enum';
import { ChartTextSkeleton } from '../ChartSkeleton';
import { getFamilyHistory } from './utils';

const FamilyMembersWithADPKD = () => {
  const { isPersonLoading, isPersonAttributesFetching, person, personId, personAccountProfileId } =
    useGetPersonAndAttributes();

  const { participantTask, isParticipantTaskLoading } =
    useGetProfileParticipantTasksQuery(
      { personAccountProfileId },
      { skip             : !personAccountProfileId,
        selectFromResult : ({ data = [], isFetching }) => ({
          participantTask          : data,
          isParticipantTaskLoading : isFetching,
        }),
      }
    );
  const coreQuestionnaireTaskId = participantTask?.find(item => item.taskTitle === TaskTitles.coreQuestionnaire)?.id;
  const { data:coreQuestionnaire, isLoading:isCoreQuestionnaireLoading } =
    useGetProfileParticipantTaskQuery(
      { personAccountProfileId, participantTaskId: coreQuestionnaireTaskId },
      { skip: !coreQuestionnaireTaskId }
    );
  const coreQuestionnaireData = coreQuestionnaire;

  const familySurveyTaskId = participantTask?.find(item => item.taskTitle === TaskTitles.familyHistory)?.id;

  const { data:familyHistory, isLoading:isFamilyHistoryLoading } =
    useGetProfileParticipantTaskQuery(
      { personAccountProfileId, participantTaskId: familySurveyTaskId },
      { skip: !familySurveyTaskId }
    );
   
  const familyHistoryEntries = getFamilyHistory(familyHistory);
  const isLoading =
    isPersonLoading ||
    isParticipantTaskLoading ||
    isFamilyHistoryLoading ||
    isCoreQuestionnaireLoading;

  const content = isLoading
    ? (
      <ChartTextSkeleton />
    )
    : familyHistoryEntries.length > 0
      ? (
        <Box
          m='20px 0px'>
          <Typography
            variant='pl1' mb={1}>
            {familyHistoryEntries}
          </Typography>
        </Box>
      )
      : (
        <Empty
          description='Fill out the Family History module'
          to={`/questionnaire/${familyHistory?.participantTaskId}`}
          buttonText='Fill out the Family History module'
          hideAction={
            !coreQuestionnaireData?.taskEntry ||
        (Boolean(coreQuestionnaireData?.taskEntry) &&
          familyHistoryEntries?.length > 0)
          }
        />
      );

  return (
    <Container>
      <Title>Family members with ADPKD</Title>
      <Description>
        Once diagnosed, you have a 50% chance of passing ADPKD on to each child.
        Around 90% of those diagnosed have a family history. Remember, few PKD
        experiences are alike.
      </Description>
      {content}
    </Container>
  );
};

export default FamilyMembersWithADPKD;
